(() => {
  const exactColors = {
    adobe: '#a95f43',
    'athletic heather': '#b7b4ad',
    bay: '#8fa58c',
    bone: '#dfd4bd',
    'bottle green': '#183f32',
    brick: '#a94e3f',
    'bubble pink': '#f08fb8',
    bubblegum: '#ef72ad',
    'burnt orange': '#bf5a2a',
    caramel: '#b97645',
    'carbon grey': '#4a4b4b',
    'charcoal heather': '#4b4b4e',
    'charcoal melange': '#55565a',
    clay: '#a96f5e',
    cobalt: '#2449b5',
    'cool heather grey': '#a5a6aa',
    cove: '#4f8a9a',
    cranberry: '#8d2343',
    crimson: '#a71930',
    crunchberry: '#c64f78',
    cypress: '#365444',
    'dark heather': '#3f4145',
    'dark heather gray': '#3d3f42',
    'desert dust': '#c4ab84',
    'dusty rose': '#bc7f82',
    evergreen: '#1f4b3b',
    fiesta: '#ed3f89',
    'flo blue': '#2d75c8',
    'french navy': '#13233b',
    grape: '#5c3b74',
    graphite: '#414246',
    'green bay': '#317866',
    'green camo': 'linear-gradient(135deg,#28362c 0 25%,#69705a 25% 50%,#3f4a37 50% 75%,#8a8065 75%)',
    heliconia: '#dc2274',
    hemp: '#aaa17f',
    'indigo blue': '#354f72',
    'irish green': '#168b4b',
    latte: '#c2a686',
    mineral: '#73777b',
    'mystic blue': '#5f799a',
    'navy blazer': '#202c43',
    'oatmeal heather': '#c8bea9',
    oyster: '#d8d2c4',
    pacific: '#397a8f',
    paprika: '#a84b35',
    pepper: '#4d4b49',
    sage: '#9aa586',
    spruce: '#234d43',
    stargazer: '#245d65',
    storm: '#53636b',
    'team gold': '#d0a52b',
    'team red': '#b52835',
    'team royal': '#2756a6',
    'true navy': '#17243c',
    'true royal': '#2854a5',
    watermelon: '#e45f70',
    yam: '#bd6335',
    'yellow haze': '#e8dc8d',
    'faded black': '#343334',
    'faded bone': '#c9c0aa',
    'faded eucalyptus': '#71877b',
    'faded khaki': '#8b846b',
    'vintage black': '#29292a',
    'vintage brown': '#604b3f',
    'vintage white': '#e7e1d5',
    'washed denim': '#6882a0',
    'blue spruce': '#285f5c',
    'green bay': '#2c7464',
    'navy melange': '#3c485b',
    'navy mélange': '#3c485b',
    'marine chine': '#48556a',
    'marine chiné': '#48556a',
    'gris chine': '#aaa9a5',
    'gris chiné': '#aaa9a5',
    'gris fonce chine': '#55575b',
    'gris foncé chiné': '#55575b',
    'bleu stone': '#6f879b',
    'bleu poudre': '#a9bfd2',
    'bleu powder': '#a9bfd2',
    'bleu atoll': '#2d9eb3',
    'bleu caraibes': '#2c9fb5',
    'bleu caraïbes': '#2c9fb5',
    'bleu lagon': '#3fa9ad',
    'bleu jean': '#537394',
    'rose sakura': '#e8a4b1',
    'rose flamingo': '#ed7191',
    'rose bonbon': '#ef80af',
    'sable du desert': '#c6ad82',
    'sable du désert': '#c6ad82',
    clear: 'repeating-conic-gradient(#ffffff 0 25%,#d8dde1 0 50%) 50%/10px 10px',
    glossy: 'linear-gradient(135deg,#0d0d0e 0 38%,#8a8a8c 48%,#171718 59%,#080809 100%)',
    matte: '#29292a'
  };

  const rules = [
    [/(off white|blanc casse|blanc cassé|ecru|écru|natural|oyster|vintage white)/, '#e9e2d4'],
    [/(white|blanc)/, '#f4f3ee'],
    [/(black|noir)/, '#111113'],
    [/(anthracite|charcoal|graphite|carbon|dark grey|dark gray|gris fonce|gris foncé)/, '#44464a'],
    [/(silver|argente|argenté)/, '#b6b8ba'],
    [/(grey|gray|gris|heather)/, '#929397'],
    [/(midnight navy|dark navy|french navy|true navy|navy|marine|bleu nuit)/, '#17263e'],
    [/(cobalt|royal|bleu roi)/, '#2854a5'],
    [/(denim|indigo|bleu jean)/, '#4e6f92'],
    [/(sky blue|light blue|pastel blue|bleu ciel|bleu clair|bleu powder)/, '#93c5df'],
    [/(aqua|turquoise|atoll|caraibe|caraïbe|lagon|teal)/, '#29a5ae'],
    [/(blue|bleu)/, '#3d6fa8'],
    [/(burgundy|bordeaux|bourgone|maroon|cranberry|canneberge|grenat)/, '#6f2335'],
    [/(crimson|red|rouge)/, '#b72832'],
    [/(neon pink|rose fluo|fuchsia|heliconia)/, '#e52b86'],
    [/(dusty rose|pale pink|pastel pink|light pink|rose clair|sakura)/, '#dca0aa'],
    [/(pink|rose|bubble)/, '#dc6f9d'],
    [/(lavande|lavender|orchidee|orchidée)/, '#9d82bb'],
    [/(purple|violet|grape)/, '#66418a'],
    [/(mint|menthe|pistache)/, '#8fc4a4'],
    [/(pine|spruce|evergreen|forest|foret|forêt|bottle|vert fonce|vert foncé)/, '#285441'],
    [/(military|army|kaki|khaki|moss|sage|green camo)/, '#657052'],
    [/(green|vert)/, '#3f7b56'],
    [/(gold|or|moutarde|mustard)/, '#c49a32'],
    [/(yellow|jaune|lemon|citron|daisy)/, '#e1cb49'],
    [/(brick|burnt orange|paprika|adobe|yam|clay)/, '#b85c39'],
    [/(orange)/, '#dc7433'],
    [/(dark chocolate|chocolat noir)/, '#3c2a24'],
    [/(brown|marron|chocolat|caramel)/, '#79543d'],
    [/(desert|sable|beige|bone|oatmeal|hemp|latte|pierre|stone)/, '#b9aa8c']
  ];

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\*/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  const singleColor = (value) => {
    const normalized = normalize(value);
    if (exactColors[normalized]) return exactColors[normalized];
    const match = rules.find(([pattern]) => pattern.test(normalized));
    return match ? match[1] : '#8a8174';
  };

  const swatchBackground = (value) => {
    const normalized = normalize(value);
    if (exactColors[normalized]) return exactColors[normalized];
    const parts = normalized
      .split(/\s*(?:\/|&|\bet\b)\s*/)
      .map((part) => part.trim())
      .filter(Boolean);
    if (parts.length > 1) {
      const colors = parts.slice(0, 3).map(singleColor);
      if (colors.length === 2) {
        return `linear-gradient(135deg,${colors[0]} 0 49%,${colors[1]} 51% 100%)`;
      }
      return `linear-gradient(135deg,${colors[0]} 0 32%,${colors[1]} 34% 65%,${colors[2]} 67% 100%)`;
    }
    return singleColor(normalized);
  };

  const selectedInputs = (picker) => [...picker.querySelectorAll('[data-option-value]:checked')]
    .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));

  const selectedValues = (picker) => selectedInputs(picker).map((input) => input.value);

  const variantMatches = (variant, values) => variant.options.every((value, index) => value === values[index]);

  const parseVariants = (picker) => {
    try {
      return JSON.parse(picker.querySelector('[data-variant-data]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const setButtonState = (button, available, compact = false) => {
    if (!button) return;
    button.disabled = !available;
    button.textContent = available ? (compact ? 'Ajouter' : 'Ajouter au panier') : 'Épuisé';
  };

  const updateAvailability = (picker, variants) => {
    const groups = [...picker.querySelectorAll('[data-option-group]')];
    const current = selectedValues(picker);
    const colorGroup = groups.find((group) => group.hasAttribute('data-color-option'));
    const colorIndex = colorGroup ? Number(colorGroup.dataset.optionIndex) : -1;

    groups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll('[data-option-value]').forEach((input) => {
        const possible = variants.some((variant) => {
          if (!variant.available || variant.options[index] !== input.value) return false;
          if (index === colorIndex) return true;
          if (colorIndex >= 0 && variant.options[colorIndex] !== current[colorIndex]) return false;
          return groups.every((otherGroup) => {
            const otherIndex = Number(otherGroup.dataset.optionIndex);
            if (otherIndex === index || otherIndex === colorIndex || otherIndex > index) return true;
            return variant.options[otherIndex] === current[otherIndex];
          });
        });
        input.disabled = !possible;
        const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        label?.setAttribute('aria-disabled', String(!possible));
      });
    });

    groups.forEach((group) => {
      const checked = group.querySelector('[data-option-value]:checked');
      if (checked?.disabled) {
        const replacement = group.querySelector('[data-option-value]:not(:disabled)');
        if (replacement) replacement.checked = true;
      }
    });
  };

  const updatePicker = (picker) => {
    const variants = picker._pk9Variants || [];
    updateAvailability(picker, variants);
    const values = selectedValues(picker);
    let variant = variants.find((item) => variantMatches(item, values));

    if (!variant) {
      updateAvailability(picker, variants);
      variant = variants.find((item) => variantMatches(item, selectedValues(picker)));
    }

    picker.querySelectorAll('[data-option-group]').forEach((group) => {
      const selected = group.querySelector('[data-option-value]:checked');
      const output = group.querySelector('[data-selected-option]');
      if (output && selected) output.textContent = selected.value;
    });

    const form = picker.closest('form');
    const idInput = form?.querySelector('input[name="id"]');
    const price = document.querySelector('[data-product-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const submit = form?.querySelector('[type="submit"]');
    const stickySubmit = document.querySelector('[data-sticky-add]');
    const message = picker.querySelector('[data-variant-message]');

    if (!variant) {
      if (message) message.textContent = 'Cette combinaison n’est pas disponible.';
      setButtonState(submit, false);
      setButtonState(stickySubmit, false, true);
      return;
    }

    if (idInput) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (price) price.textContent = money(Number(variant.price));
    if (stickyPrice) stickyPrice.textContent = money(Number(variant.price));
    setButtonState(submit, variant.available);
    setButtonState(stickySubmit, variant.available, true);
    if (message) message.textContent = variant.available ? '' : 'Cette combinaison est actuellement épuisée.';

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const initPicker = (picker) => {
    if (picker.dataset.initialized === 'true') return;
    picker.dataset.initialized = 'true';
    picker._pk9Variants = parseVariants(picker);

    picker.querySelectorAll('[data-color-swatch]').forEach((swatch) => {
      swatch.style.setProperty('--pk9-swatch', swatchBackground(swatch.dataset.colorValue));
    });

    picker.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-value]')) return;
      updatePicker(picker);
    });

    updatePicker(picker);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-variant-picker]').forEach(initPicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
